import { Provider, TemplateRef, ViewChild, ViewChildDecorator, forwardRef } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Observable } from 'rxjs';

/**
 * Stellt Templates für "AdminFormFieldProvider" bereit, die serviceübergreifend
 * benötigt werden, um bspw. die Portalseitenauswahl "schön" darzustellen statt
 * eines simplen text-basierten Eingabefeldes.
 *
 * Wird in {@link AdminFormFieldComponent} genutzt/angezeigt.
 *
 * <strong>Alle Implementierungen sollten ihr Template mittels Angular-Query
 * ({@link ViewChild}/{@link ViewChildDecorator}) mit dem Flag <code>{static: true}</code>
 * auflösen, damit das Template dort in "ngOnInit" definitiv aufgelöst ist.</strong>
 *
 */
export abstract class IAdminFormFieldProvider {
    /**
     * Liefert das Template für das Formularfeld.
     *
     * @param type der Typ des Formularfeldes; entspricht dem Feld "type" aus {@link IPortalComponentInputMetadata}
     * @param multi true heißt, dass ein Formularfeld zur Eingabe mehrerer Werte angezeigt werden soll;
     *        entspricht dem Feld "type" aus {@link IPortalComponentInputMetadata}
     * @returns das Template für das Formularfeld. Als Observable, da es ggf. erst nachgeladen werden muss.
     */
    abstract getFormFieldTemplate(type: string, multi?: boolean): Observable<TemplateRef<FormFieldParams>>;
}

/**
 * Die Templates müssen jeweils mindestens folgende Parameter im Outlet-Context unterstützen.
 * Es dürfen weitere Parameter unterstützt werden.
 */
export interface FormFieldParams {
    /** Der FormControl-Name, an den der Wert des Formularfeldes gebunden wird. */
    formControlName: string;

    /** Die FormGroup, zu der das Formularfeld gehört. */
    formGroup: UntypedFormGroup;

    /** Das anzuzeigende Label. Bei komplexen Formularfeldern kann das auch als Überschrift verwendet werden.*/
    label: string;

    /** ob die Eingabe erforderlich ist */
    required: boolean;

    /** der Text für die Info-Box*/
    toolTip?: string;
}

// Siehe https://angular.io/docs/ts/latest/cookbook/dependency-injection.html#!#provideparent
export function provideAdminFormFields(component: any) {
    return { provide: IAdminFormFieldProvider, useExisting: forwardRef(() => component) } as Provider;
}

